import React, { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { RequestQuote } from "@mui/icons-material";
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { SETTLEMENTS_ENDPOINT } from '../../../../consts';
import styles from './clientSettlements.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { getMonthNames } from '../../../../utils';

export const ClientSettlements = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const canViewSettlements = useHasPermission("settlement.view_settlement");

  const monthNames = useMemo(() => getMonthNames(t), [t]);

  const columns: GridColDef[] = useMemo(() => [
    {
      field: "month",
      headerName: t("Month"),
      valueFormatter: (value) => {
        if (value === null || value === undefined) return '';
        const monthNum = typeof value === 'number' ? value : parseInt(value);
        return monthNames[monthNum] || value;
      },
    },
    {
      field: "year",
      headerName: t("Year"),
    },
    {
      field: "total_value",
      headerName: t("Net Total"),
      type: "number",
    },
  ], [t, monthNames]);

  const handleRowClick = (monthKey: string) => {
    navigate(`/clients/${id}/settlements/${monthKey}`);
  };

  if (!canViewSettlements) {
    return null;
  }

  const settlementsUrl = `${SETTLEMENTS_ENDPOINT}monthly-summary/?client=${id}`;

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<RequestQuote />}
        title={t('Settlements Summary')}
        url={settlementsUrl}
        gridSettingsKey="CLIENT_SETTLEMENTS_SUMMARY"
        columns={columns}
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
